import { ById, DinCollectionMethod, ProductApi, ShopApi } from 'common/types';

export interface ProductDinUpdate {
	field: 'din' | 'soleLength';
	type: 'add' | 'remove';
}
export interface DinOptions {
	dinCollectionMethod: DinCollectionMethod;
	useDinVariation: boolean;
	productDinUpdates: ById<ProductDinUpdate>;
}

export const getDinOptionsFromShopInfo = (shopInfo: ShopApi): DinOptions => {
	return {
		dinCollectionMethod: shopInfo.dinCollectionMethod ?? null,
		useDinVariation: !!shopInfo.plugins?.din?.useDinVariation,
		productDinUpdates: {},
	};
};

export const getSelectedSkuProductIds = (products: ProductApi[], dinOptions: DinOptions) => {
	const alreadySelectedSkiProductIds = products.filter((p) => p.collectDin).map((p) => p.id);
	const addedIds = Object.entries(dinOptions.productDinUpdates)
		.filter(([_productId, info]) => info.field === 'din' && info.type === 'add')
		.map(([productId]) => productId);
	const removedIds = Object.entries(dinOptions.productDinUpdates)
		.filter(([_productId, info]) => info.field === 'din' && info.type === 'remove')
		.map(([productId]) => productId);
	return [...alreadySelectedSkiProductIds, ...addedIds].filter((id) => !removedIds.includes(id));
};

export const getSelectedBootProductIds = (products: ProductApi[], dinOptions: DinOptions) => {
	const alreadySelectedBootProductIds = products
		.filter((p) => p.collectBootSoleLength)
		.map((p) => p.id);
	const addedIds = Object.entries(dinOptions.productDinUpdates)
		.filter(([_productId, info]) => info.field === 'soleLength' && info.type === 'add')
		.map(([productId]) => productId);
	const removedIds = Object.entries(dinOptions.productDinUpdates)
		.filter(([_productId, info]) => info.field === 'soleLength' && info.type === 'remove')
		.map(([productId]) => productId);
	return [...alreadySelectedBootProductIds, ...addedIds].filter((id) => !removedIds.includes(id));
};
